/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { browser } from '@atlaskit/editor-common/browser';
import { codeLg, codeMd, codeSm, componentFromKeymapWrapperStyles } from './styles';
var getKeyParts = function getKeyParts(keymap) {
  var shortcut = keymap[browser.mac ? 'mac' : 'windows'];
  if (browser.mac) {
    shortcut = shortcut.replace('Alt', 'Opt');
  }
  return shortcut.replace(/\-(?=.)/g, ' + ').split(' ');
};
export var shortcutNamesWithoutKeymap = ['table', 'emoji', 'mention', 'quickInsert'];
export var getComponentFromKeymap = function getComponentFromKeymap(keymap) {
  var keyParts = getKeyParts(keymap);
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("span", {
      css: componentFromKeymapWrapperStyles
    }, keyParts.map(function (part, index) {
      if (part === '+') {
        return jsx("span", {
          key: "".concat(keyParts, "-").concat(index)
        }, ' + ');
      } else if (part === 'Cmd') {
        return (
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
          jsx("span", {
            css: codeSm,
            key: "".concat(keyParts, "-").concat(index)
          }, "\u2318")
        );
      } else if (['ctrl', 'alt', 'opt', 'shift'].indexOf(part.toLowerCase()) >= 0) {
        return (
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
          jsx("span", {
            css: codeMd,
            key: "".concat(keyParts, "-").concat(index)
          }, part)
        );
      } else if (['f9', 'f10'].indexOf(part.toLowerCase()) >= 0) {
        return (
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
          jsx("span", {
            css: codeLg,
            key: "".concat(keyParts, "-").concat(index)
          }, part)
        );
      } else if (part.toLowerCase() === 'enter') {
        return (
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
          jsx("span", {
            className: "enter-keymap",
            css: codeSm,
            key: "".concat(keyParts, "-").concat(index)
          }, '⏎')
        );
      }
      return (
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        jsx("span", {
          css: codeSm,
          key: "".concat(keyParts, "-").concat(index)
        }, part.toUpperCase())
      );
    }))
  );
};